import { deleteSource } from "@/apis/cs-rag/route";
import type { Source } from "@/apis/cs-rag/types";
import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { csRagQueries } from "@/queries";
import { popModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

interface DeleteSourceModalProps {
  source: Source;
}

export const DeleteSourceModal: React.FC<DeleteSourceModalProps> = ({
  source,
}) => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: () => deleteSource(source.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: csRagQueries.sources().queryKey,
      });
      toast.success("자료가 삭제되었습니다.");
      popModal();
    },
    onError: () => {
      toast.error("삭제에 실패했습니다. 다시 시도해주세요.");
    },
  });

  return (
    <ModalWrapper className="w-[400px] rounded-[10px] p-6 gap-6 bg-white">
      <div className="flex flex-col gap-2">
        <h2 className="headline-1-semibold text-label-normal">
          자료를 삭제합니다
        </h2>
        <p className="body-2-normal-regular text-label-alternative">
          '{source.title}'을(를) 삭제합니다.
          <br />이 작업은 되돌릴 수 없습니다.
        </p>
      </div>
      <div className="flex justify-end gap-2">
        <Button
          onClick={popModal}
          disabled={deleteMutation.isPending}
          size={36}
        >
          취소
        </Button>
        <Button
          variant="solid"
          color="primary"
          size={36}
          onClick={() => deleteMutation.mutate()}
          disabled={deleteMutation.isPending}
          className="!bg-red-600 hover:!bg-red-700"
          leftIcon={
            deleteMutation.isPending ? (
              <Loader2 className="size-4 animate-spin" />
            ) : undefined
          }
        >
          삭제
        </Button>
      </div>
    </ModalWrapper>
  );
};
